import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';


export enum NoMatchesComponentAlign {
    Left = 'left',
    Right = 'right',
    Center = 'center',
}

@Component({
    selector: 'ui-no-matches',
    imports: [NgClass, TranslatePipe],
    templateUrl: './no-matches.component.html',
    styleUrls: ['./no-matches.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoMatchesComponent {
    @Input() public align: NoMatchesComponentAlign = NoMatchesComponentAlign.Center;
    @Input() public isSearchResults: boolean;
    @Input() public label: string;
}
